import ReactGA from "react-ga4";

// see https://docs.google.com/spreadsheets/d/1I-N5cBZ1vaWFGGIpZbB0HvXPBYb7a93xFFTKfWBbjPY/edit#gid=0
export const EventType = {
  LikeStudyRecord: "like_study_record",
  UnlikeStudyRecord: "unlike_study_record",
  CancelAttachmentPreview: "cancel_attachment_preview",
} as const;

// 学習記録をいいねしたときに送信するイベント(No.1)
type LikeStudyRecordEvent = {
  type: typeof EventType.LikeStudyRecord;
  studyRecordId: string;
  studentId: string;
};
type UnlikeStudyRecordEvent = {
  type: typeof EventType.UnlikeStudyRecord;
  studyRecordId: string;
  studentId: string;
};
// メッセージの添付のプレビュー画面で「キャンセル」を押したときに送信するイベント。
// 送る前に取り違えに気づいた件数（ヒヤリハット）を数える
type CancelAttachmentPreviewEvent = {
  type: typeof EventType.CancelAttachmentPreview;
  fileType: "pdf" | "image";
};
type Event =
  | LikeStudyRecordEvent
  | UnlikeStudyRecordEvent
  | CancelAttachmentPreviewEvent;
export const sendUserEvent = (e: Event) => {
  switch (e.type) {
    case EventType.LikeStudyRecord:
    case EventType.UnlikeStudyRecord:
      ReactGA.event(e.type, {
        student_id: e.studentId,
        study_record_id: e.studyRecordId,
      });
      break;
    case EventType.CancelAttachmentPreview:
      ReactGA.event(e.type, { file_type: e.fileType });
  }
};
